import { ShieldCheck, FileCheck2, Users, Grid3x3, GraduationCap, Bot } from "lucide-react";
import { EyebrowPill } from "@/components/shared/EyebrowPill";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { FeatureCard } from "@/components/shared/FeatureCard";

const capabilities = [
  {
    icon: ShieldCheck,
    title: "Governance & Risk",
    description:
      "CEO Governance Portal, Governance Meetings with 100-point readiness scoring, Annual Declaration, Fit & Proper Person, Regulatory Intelligence, and eight further modules — everything Governing Persons and Compliance Managers need to demonstrate governance maturity under Outcome Standard 2.",
  },
  {
    icon: FileCheck2,
    title: "TAS Quality Engine",
    description:
      "Live validation against training.gov.au, packaging rules checking, AI-drafted narrative sections, AOT hours calculation, and assessment conditions auto-populated from the National Register. A TAS built to withstand ASQA scrutiny, not just tick a box.",
  },
  {
    icon: Users,
    title: "Industry Consultation",
    description:
      "The complete Standard 1.2 compliance cycle — CONSULT, ANALYSE, DECIDE, ACT, REVIEW. AI extracts themes across six Standard 1.2 categories. Every theme accepted, deferred, or rejected with documented rationale — the evidence ASQA expects under Standard 1.2(b).",
  },
  {
    icon: Grid3x3,
    title: "Trainers Matrix",
    description:
      "Every Trainer/Assessor mapped against every training product on scope. Credential status, currency status, and gap indicators on one screen. All five Credential Policy tiers tracked per trainer — with automated alerts before gaps become audit findings.",
  },
  {
    icon: GraduationCap,
    title: "Students & Support",
    description:
      "12 modules covering the full student lifecycle — LLND screening, reasonable adjustments, at-risk identification, complaints and appeals, placement wellbeing, diversity and inclusion, and work health and safety. All connected to Governance Meetings for oversight.",
  },
  {
    icon: Bot,
    title: "ComplyBot",
    description:
      "Your AI compliance assistant — powered by Claude (Anthropic) and purpose-built for the Australian VET sector. Ask a Standards question, get a Standards-referenced answer. Draft documents, check obligations, and get regulatory guidance without leaving the platform.",
  },
];

const Solution = () => {
  return (
    <section id="features" className="py-20 md:py-28 bg-ch-cyanSoft text-ch-acai">
      <div className="container">
        <div className="text-center mb-14 animate-fade-up">
          <EyebrowPill>Platform Capabilities</EyebrowPill>
          <SectionHeading className="mb-5">
            Your Complete RTO Compliance Platform
          </SectionHeading>
          <p className="text-lg text-ch-acai/75 max-w-3xl mx-auto">
            57 features across six navigation groups — every one mapped directly to the Standards for RTOs 2025, the Credential Policy, and the Compliance Requirements.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {capabilities.map((capability, index) => (
            <FeatureCard
              key={capability.title}
              icon={capability.icon}
              title={capability.title}
              align="center"
              iconStyle="gradient"
              className={`animate-fade-up animate-delay-${(index + 1) * 100}`}
            >
              {capability.description}
            </FeatureCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solution;
